import dayjs from 'dayjs';
import { decodeUtf8 } from "base/backbone/lib/utilities/helpers";

Pixlee.module('UploaderV3App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.preventClosing = {
        uploaderCollection: null
    };
    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        className: 'wrap',
        id: 'uploader_widget',
        regions: {
            mainContent: '#content_holder',
            uploadHolder: '#upload_holder',
            extraContent: '#info_holder'
        },
        ui: {
            alert: '.alert',
            alertFormat: '#alert_format',
            breadcrumbsContainer: '#breadcrumbs_container',
            breadcrumbsHiddenTitle: '#breadcrumbs_hidden_title',
            breadcrumb: '.breadcrumb',
            closeButton: '#close',
            fileAlert: '#file_alert',
            mainContent: '#content_holder',
            outsideUploader: '#uploader_overlay',
            uploaderFrame: '#uploader_frame',
            uploaderAlert: '#uploader_alert',
            uploaderBackAlert: '#uploader_back_alert',
            uploaderError: '#uploader_error',
            uploaderErrorButton: '#uploader_error_button',
            topBar: '#top_bar',
            pickSource: '#pick_source',
            selectContent: '#select_content',
            reviewSubmission: '#review_submission',
            submitContent: '#submit_content',
            noCloseUploader: '#no',
            noAlertBack: '#alert_back_no',
            yesCloseUploader: '#yes',
            yesAlertBack: '#alert_back_yes',
            yesFile: '#yes_file'
        },
        events: {
            'click @ui.yesFile': 'onHideAlert',
            'click @ui.noCloseUploader': 'onHideAlert',
            'click @ui.noAlertBack': 'onHideAlert',
            'click @ui.uploaderErrorButton': 'onHideAlert',
            'click @ui.yesCloseUploader': 'closeParentIFrame',
            'click @ui.yesAlertBack': 'goBackUploaderBackAlert',
            'click @ui.pickSource': 'checkPickSource',
            'click @ui.selectContent': 'checkSelectContent',
            'click @ui.reviewSubmission': 'showReviewSubmission',
            'click @ui.submitContent': 'showSubmitContent',
            'click @ui.closeButton': 'onBeforeCloseUploader',
            'click @ui.outsideUploader': 'onBeforeCloseUploader',
            'keydown': 'handleKeyboard'
        },
        initialize: function() {
            this.lastActiveElement = null;

            /* Specifiying the list of focusable elements is important for trapping keyboard focus in a modal popup.
             * Uploader elements and alert elements are stored in separate properties because
             * when an alert becomes active we also need to give uploader elements a tabindex of -1 in order to hide them from screen readers.
             */

            // for uploader contents
            this.focusableElements = [];
            this.activeFocusIndex = 0;

            // for alert box contents
            this.alertFocusableElements = [];
            this.activeAlertFocusIndex = 0;
        },
        onShow: function() {
            this.trigger('keen:opened:uploader');
        },
        closeUploader: function() {
            var msg = {
                name: 'pixlee:close:uploader',
                type: 'action',
                source: 'uploader',
                destination: 'parent',
                data: {}
            };

            window.parent.postMessage(JSON.stringify(msg), '*');
        },
        handleKeyboard: function(e) {
            var alertIsActive = this.ui.alert.hasClass('active');

            this.mapKeyboardInteractionToElements(e);

            switch (e.key) {
                case 'Enter':
                    /* ENTER */
                    // find the last active element before alert appears
                    if (_.isFalsy(alertIsActive) && this.focusableElements.indexOf(e.target) > -1) {
                        this.lastActiveIndex = this.focusableElements.indexOf(e.target);
                    }

                    // do not allow breadcrumb buttons to lose focus when being selected
                    if (e.target.classList.contains('breadcrumb') && e.target.getAttribute('role') === 'button') {
                        $(e.target).focus();
                    }

                    break;
                case 'Tab':
                    /* TAB ---
                     * In order to trap tab focus in modal, we check if the current item is part of our indexed focusable elements;
                     * 1) if user tabs (forward) to the last indexed element, next element is the first of index
                     * 2) if user presses shift + tab (backwards) and reaches first indexed element, next element is last element of index
                     */

                    if (this.focusableElements.indexOf(e.target) > -1) {
                        this.activeFocusIndex = this.focusableElements.indexOf(e.target);
                        this.cycleTab(e, this.focusableElements, this.activeFocusIndex);
                    }

                    // alert box
                    if (_.isTruthy(alertIsActive)) {
                        if (this.alertFocusableElements.indexOf(e.target) > -1) {
                            this.activeAlertFocusIndex = this.alertFocusableElements.indexOf(e.target);
                            this.cycleTab(e, this.alertFocusableElements, this.activeAlertFocusIndex);
                        } else {
                            // this catches when onShowAlert is triggered from another view; we need to set focus of the first indexed element
                            e.preventDefault();
                            this.alertFocusableElements[0].focus();
                        }
                    }
                    break;
                case 'Esc':
                case 'Escape':
                    /* ESC ---
                     * A user should be able to close a modal using the esc key on a keyboard;
                     * 1) if user opens uploader, does not select any photos to upload, hits esc; uploader will close
                     * 2) if user opens uploader, selects some photos without submitting, hits esc; alert prompt appears
                     * 3) if alert prompt is active and photos are not selected, user hits esc key; just close alert prompt
                     * 4) if alert prompt is active, user hits esc key, alert assumes "no" and closes
                     */

                    this.onBeforeCloseUploader(e);
                    break;
                default:
                    break;
            }
        },
        // when user clicks on X or outside of uploader
        onBeforeCloseUploader: function(e) {
            const isOnLastPage = this.ui.mainContent.has('#panel_confirmation').length > 0;
            if (isOnLastPage) { // photos already submitted, can just close safely
                return this.closeParentIFrame();
            }

            const alertIsActive = this.ui.alert.hasClass('active');
            const photosSelected = Show.preventClosing.uploaderCollection;

            // find the last active element before alert appears
            if (_.isFalsy(alertIsActive) && this.focusableElements.indexOf(e.target) > -1) {
                const lastActiveIndex = this.focusableElements.indexOf(e.target);
                this.lastActiveElement = this.focusableElements[lastActiveIndex];
            }
            // if no photos are selected or we are in the confirm panel, failed submission panel, or first panel
            if (!photosSelected) {
                if (_.isTruthy(alertIsActive)) {
                    this.onHideAlert();
                } else {
                    this.closeParentIFrame();
                }
            } else {
                // if there are photos selected and we're not explicitly stopping the alert from appearing
                this.onGetFocusIndex(this.ui.uploaderAlert, true);
                this.setTabindexOfElements(this.focusableElements, '-1');
                this.ui.uploaderAlert.toggleClass('active');

                if (_.isTruthy(alertIsActive)) {
                    this.onHideAlert();
                } else {
                    e.preventDefault(); // prevents clicking "no" right away
                    this.ui.noCloseUploader.focus();
                }
            }
        },
        // Creates an index of focusable elements for keyboard accessibility
        onGetFocusIndex: function(el, isAlert) {
            if (_.isTruthy(isAlert)) {
                // create focus index for alert prompts
                this.alertFocusableElements = this.createFocusIndex([el]);
            } else {
                /* Create a focus index for the panel passed to this function (e.g. extraContent panel),
                 * otherwise create an index for the main content
                 */
                var panel = _.isTruthy(el) ? el : this.mainContent.$el;

                /* A focus index for the uploader includes the:
                 * 1) the breadcrumb top bar
                 * 2) current panel (e.g. home, select content, review, info panel)
                 */
                this.focusableElements = this.createFocusIndex([this.ui.topBar, panel]);
            }
        },
        goBackUploaderBackAlert: function() {
            if (this.ui.uploaderBackAlert.hasClass('two')) {
                this.trigger('show:select:content');
            } else {
                this.trigger('show:home:view');
            }
            this.onHideAlert();
        },
        checkSelectContent: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Select Content', currentStepNumber);
            this.trigger('check:select:content');
        },
        checkPickSource: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Choose Source', currentStepNumber);
            this.trigger('check:pick:source');
        },
        showSelectContent: function() {
            this.trigger('show:select:content');
        },
        showReviewSubmission: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Review Submission', currentStepNumber);
            this.trigger('show:review:submission');
        },
        showSubmitContent: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass.match(/one|two|three|four/g)[0];
            this.trigger('keen:clicked:navigation', 'Submit Content', currentStepNumber);
            this.trigger('show:submit:content');
        },
        /* This method should be used for triggering an alert prompt from another part of the view;
         * Pass the id of the alert prompt and additional data object;
         * e.g. there are different types of file upload alerts so we pass the alert id (file_alert)
         * and any data-attribute data to dislpay
         */
        onShowAlert: function(alertPrompt, data) {
            alertPrompt.addClass('active');
            this.onGetFocusIndex(alertPrompt, true);
            this.setTabindexOfElements(this.focusableElements, '-1');

            if (data.error_type) {
                alertPrompt.find('#' + data.error_type).addClass('active');
            }

            if (data.alert_format) {
                this.ui.alertFormat.text(data.alert_format);
            }
        },
        onHideAlert: function() {
            this.ui.alert.find('.active').removeClass('active');
            this.ui.alert.removeClass('active');
            // resume focus on elements
            this.setTabindexOfElements(this.focusableElements, '0');

            // if there is no last active element specified, return to the first element in index
            if (_.isTruthy(this.lastActiveElement)) {
                this.lastActiveElement.focus();
            } else {
                this.focusableElements[0].focus();
            }
        },
        onShowMainContent: function() {
            if (_.isTruthy(this.mainContent.$el)) {
                this.mainContent.$el.show();
            }
        },
        onShowUploadHolder: function() {
            if (_.isTruthy(this.uploadHolder.$el)) {
                this.uploadHolder.$el.show();
            }
        },
        onHideMainContent: function() {
            if (_.isTruthy(this.mainContent.$el)) {
                this.mainContent.$el.hide();
            }
        },
        onHideUploadHolder: function() {
            if (_.isTruthy(this.uploadHolder.$el)) {
                this.uploadHolder.$el.hide();
            }
        },
        onShowUploaderBackAlert: function(step) {
            this.onGetFocusIndex(this.ui.uploaderBackAlert, true);
            this.setTabindexOfElements(this.focusableElements, '-1');
            this.ui.uploaderBackAlert.addClass('active', step);
            this.ui.noAlertBack.focus();
        },
        onUpdateBreadcrumb: function(step, backwards) {
            var furthestStep = this.ui.breadcrumbsContainer.attr('class');
            var currStep = step;
            var furthestStepInt = this.mapStep(furthestStep);
            var currStepInt = this.mapStep(currStep);

            // If the uploader has just been opened (the first step is the only active step)
            var uploaderFirstLoad = currStepInt === 1 && furthestStepInt === 1;

            // update current step header for screen readers and structure
            var stepString = this.ui.breadcrumbsContainer.find('.breadcrumb.' + currStep + ' .text').text();
            this.ui.breadcrumbsHiddenTitle.text(stepString);

            this.focusOnBreadcrumb(uploaderFirstLoad);

            if (step === 'hide') {
                this.ui.topBar.addClass('hidden');
            } else if (step === 'disabled') {
                this.ui.breadcrumbsContainer.addClass('disabled');
            } else if (backwards || currStepInt > furthestStepInt) {
                this.ui.breadcrumbsContainer.removeClass();
                this.ui.breadcrumbsContainer.addClass(step);
            }
        },
        focusOnBreadcrumb: function(uploaderFirstLoad) {
            // If the uploader has just been opened, focus on the close button
            if (uploaderFirstLoad) {
                this.ui.closeButton.focus();
            } else {
                this.ui.breadcrumbsContainer.find('.active').focus();
            }
        },
        mapStep: function(step) {
            // BREADCRUMBS: steps 1, 2, 3, 4
            // Only add tabindex (focusable items) for the ones that are active and that are clickable
            // aria-current is used to represent the current step within a process
            var num = 0;
            var tabElem;

            this.ui.breadcrumbsContainer.children().removeClass('active').removeAttr('tabindex aria-current');
            switch (step) {
                case 'one':
                    num = 1;
                    tabElem = this.ui.pickSource;
                    break;
                case 'two':
                    num = 2;
                    tabElem = this.ui.selectContent;
                    break;
                case 'three':
                    num = 3;
                    tabElem = this.ui.reviewSubmission;
                    break;
                case 'four':
                    num = 4;
                    tabElem = this.ui.submitContent;
                    break;
                default:
                    break;
            }

            // highlight corresponding breadcrumb
            if (_.isTruthy(tabElem)) {
                tabElem.addClass('active').attr({
                    'tabindex': '0',
                    'aria-current': 'step'
                });
            }
            if (num > 1) {
                this.ui.pickSource.attr('tabindex', '0');
            }
            if (num > 2) {
                this.ui.selectContent.attr('tabindex', '0');
            }
            if (num > 3) {
                this.ui.reviewSubmission.attr('tabindex', '0');
            }

            return num;
        },
        closeParentIFrame: function() {
            var targetClass = this.ui.breadcrumbsContainer.find('.active').attr('class');
            var currentStepNumber = targetClass ? targetClass.match(/one|two|three|four/g)[0] : 'four';
            this.trigger('keen:canceled:submission', currentStepNumber);

            this.closeUploader();
        },
        templateHelpers: function() {
            var albumType = this.options.currentAlbum && this.options.currentAlbum.album_type ? this.options.currentAlbum.album_type : '';
            return {
                albumType: albumType
            };
        }
    });
    Show.Layout.include(['AccessibilityHelpers']);

    Show.Home = App.Views.ItemView.extend({
        template: require('./templates/home_panel.jst.ejs'),
        id: 'panel_home',
        className: 'panel',
        triggers: {
            'click #source_desktop': 'show:desktop:drag:drop',
            'click #info_button': 'show:info'
        },
        ui: {
            facebook: '#source_facebook',
            googlePhotos: '#source_google_photos'
        },
        events: {
            'click @ui.facebook': 'facebookLogin',
            'click @ui.googlePhotos': 'googlePhotosLogin'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'one', true);
            // create index of focusable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
        },
        facebookLogin: function() {
            var _this = this;
            App.execute('facebook:login:photos', function(socialLogin) {
                _this.trigger('show:facebook', socialLogin);
            });
        },
        googlePhotosLogin: function() {
            var _this = this;
            App.execute('google:login:photos', function(socialLogin) {
                _this.trigger('show:gphotos', socialLogin);
            });
        },
        templateHelpers: {
            infoButton: function() {
                return gon.display_options.infoButton;
            }
        }
    });

    Show.ConfirmPanel = App.Views.ItemView.extend({
        template: require('../shared/confirm.jst.ejs'),
        id: 'panel_confirmation',
        className: 'panel',
        ui: {
            'finish': '#finish',
            'confirmButton': '.confirm_button'
        },
        events: {
            'click @ui.finish': 'closeParentIFrame'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'hide');

            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);

            // focus on bottom button when panel first appears
            this.ui.confirmButton.focus();
        },
        closeParentIFrame: function() {
            if ('parentIFrame' in window) {
                window.parentIFrame.close();
            }
        },
        templateHelpers: function() {
            return {
                redirect_url: gon.display_options.thankYouUrl_input
            };
        }
    });

    Show.DragDrop = App.Views.Layout.extend({
        template: require('./templates/drag_drop_panel.jst.ejs'),
        id: 'panel_drag_drop',
        className: 'panel',
        ui: {
            'fileuploader': '#fileuploader',
            'fileInput': '#file_input',
            'dragDropTitle': '#drag_drop_form',
            'dragDropContainer': '#drag_drop_container'
        },
        events: {
            'click @ui.fileuploader': 'getFile',
            'onchange @ui.fileInput': 'sub'
        },
        initialize: function(options) {
            this.connectedUser = options.connectedUser;
            this.contentCount = 0;
        },
        onShow: function() {
            this.create();
            this.trigger('update:breadcrumb', 'two', true);

            // create index of focusable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
            this.navigationWarning = function(e) {
                // If we haven't been passed the event get the window.event
                //_this.ui.uploaderAlert.show();
                e = e || window.event;
                var message = 'Upload has not finished!';
                // For IE6-8 and Firefox prior to version 4
                if (e) {
                    e.returnValue = message;
                }
                // For Chrome, Safari, IE8+ and Opera 12+
                return message;
            };
        },
        getFile: function(e) {
            // prevent button from automatically submitting form
            e.preventDefault();
            this.ui.fileInput.click();
        },
        create: function() {
            var config = App.config.toJSON();
            var _this = this;
            // An array of album photo ids to send in the final event when 'show:confirm:panel' is triggered;
            this.uploadedAlbumPhotoIds = [];
            this.ui.dragDropTitle.fileupload({
                dataType: 'text',
                autoUpload: true,
                url: config.s3_bucket_url,
                acceptFileTypes: /(\.|\/)(mp4|mov|m4v|jpe?g|png|gif)$/i,
                maxFileSize: 300000000,
                maxNumberOfFiles: 20,
                previewMaxWidth: 133,
                previewMaxHeight: 133,
                start: function() {
                    App.execute('show:uploader:loader');
                },
                add: function(e, data) {
                    //I think there's some issue with the inclusion of external plugins for the library
                    //just do the checks manually for now
                    //http://stackoverflow.com/questions/17451629/maxfilesize-and-acceptfiletypes-in-blueimp-file-upload-plugin-do-not-work-why
                    if (_this.collection.length >= 20) {
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_amount'
                        });
                        $('#yes_file').click(function() {
                            $(_this.ui.dragDropContainer).hide();
                            _this.trigger('show:review:panel', 'desktop');
                        });
                        return false;
                    }
                    if (data.files[0].size > 300000000) {
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_size'
                        });
                        if (!_this.collection.length) {
                            _this.trigger('reset:view');
                        }
                        return false;
                    }
                    if (!data.files[0].name.match(/(\.|\/)(mp4|mov|m4v|jpe?g|png|gif)$/i)) {
                        var fileFormat = data.files[0].name.split('.');
                        _this.trigger('show:alert', $('#file_alert'), {
                            error_type: 'file_type',
                            alert_format: fileFormat[fileFormat.length - 1]
                        });
                        if (!_this.collection.length) {
                            _this.trigger('reset:view');
                        }
                        return false;
                    }
                    var model = new App.Entities.Model(data);
                    model.set('originalFile', data.originalFiles[0]);
                    model.set('uid', _this.collection.length);
                    if (data.files && data.files[0]) {
                        if (window.URL) {
                            var blob = window.URL.createObjectURL(data.files[0]);
                            model.set('dataUrl', blob);
                            _this.collection.add(model);
                        } else {
                            var reader = new FileReader();
                            reader.onload = function() {
                                model.set('dataUrl', reader.result);
                                _this.collection.add(model);
                            };
                            reader.readAsDataURL(data.files[0]);
                        }
                    }
                    _this.contentCount = _this.collection.length;
                    _this.ui.dragDropContainer.hide();
                    Show.preventClosing.uploaderCollection = _this.contentCount;

                    // show review panel
                    _this.trigger('show:review:panel', 'desktop');
                    window.onbeforeunload = _this.navigationWarning;
                }
            });
        },
        sub: function(obj) {
            var file = obj.value;
            var fileName = file.split('\\');
            this.ui.fileuploader.html(fileName[fileName.length - 1]);
            this.ui.dragDropTitle.submit();
        }
    });

    Show.ReviewPanelProductItem = App.Views.ItemView.extend({
        template: require('./templates/review_panel_product_item.jst.ejs'),
        className: 'review_panel_product_item',
        ui: {
            removeButton: '.remove_product_button'
        },
        triggers: {
            'click @ui.removeButton': 'remove:product:from:photo'
        },
        templateHelpers: function() {
            const productPhoto = decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'));

            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                return {
                    src: productPhoto,
                    alt: decodeUtf8(this.model.get('title')),
                    tag: this.model.tagName,
                };
            } else {
                return {
                    src: productPhoto,
                    alt: decodeUtf8(this.model.get('name')),
                };
            }
        }
    });

    Show.ReviewPanelItem = App.Views.CompositeView.extend({
        template: require('./templates/review_panel_item.jst.ejs'),
        className: 'photo_item_review',
        ui: {
            captionText: '.caption',
            deleteContent: '.delete_content',
            productField: '.product_field',
            productTagButton: '.product_tag_button'
        },
        childView: Show.ReviewPanelProductItem,
        childViewContainer: '.product_list',
        childEvents: {
            'remove:product:from:photo': function(view) {
                this.collection.remove(view.model);
                this.render();
            }
        },
        events: {
            'change @ui.captionText': 'changeCaption',
            'change @ui.productField': 'changeProductField'
        },
        triggers: {
            'click @ui.deleteContent': 'remove:content',
            'click @ui.productTagButton': 'show:product:search',
            'click @ui.deleteContent': 'delete:upload'
        },
        initialize: function(options) {
            this.source = options.source;
            if (!options.model.has('products')) {
                options.model.set('products', new Backbone.Collection());
            }
            this.collection = options.model.get('products');
        },
        onShow: function() {
            this.triggerMethod('update:breadcrumb', 'three');
            if (this.model.get('type') === 'video') {
                this.$el.addClass('content_video');
            } else {
                this.$el.addClass('content_image');
            }
        },
        changeCaption: function() {
            this.model.set('caption', this.ui.captionText.val().trim());
        },
        changeProductField: function() {
            this.model.set('uploader_product_input', this.ui.productField.val().trim());
        },
        templateHelpers: function() {
            return _.extend(App.request('concern', 'PhotoHelpers'), {
                isVid: function() {
                    return this.files && this.files[0].type.indexOf('video') !== -1;
                },

                getUniqueId: function() {
                    return 'file_' + this.uid;
                },

                thumbnailUrl: function() {
                    return this.dataUrl || this.picture || this.baseUrl;
                },

                hasProducts: this.model.has('products') && !this.model.get('products').isEmpty(),
                searchMode: gon.current_account.uploader_product_search_mode
            });
        }
    });

    Show.ReviewPanel = App.Views.CompositeView.extend({
        template: require('./templates/review_panel.jst.ejs'),
        behaviors: {
            UploadContentValidation: {}
        },
        childView: Show.ReviewPanelItem,
        childViewOptions: function() { return { source: this.source }; },
        childViewContainer: '#social_review_wrapper',
        id: 'panel_review',
        className: 'panel',
        childEvents: {
            'update:breadcrumb': 'onChildUpdateBreadcrumb',
            'delete:upload': 'onChildDeleteUpload',
            'show:product:search': 'onShowProductSearch',
            'show:select:content': 'onShowSelectContent',
            'remove:content': 'onRemoveContent'
        },
        initialize: function(options) {
            this.source = options.source;
            this.connectedUser = Show.connectedUser;
        },
        onShow: function() {
            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
        },
        onShowSubmitContentPanel: function() {
            Show.connectedUser.set('uniqueID', gon.distinct_user_hash);
            this.trigger('show:submit:content');
        },
        onShowProductSearch: function(childView) {
            this.trigger('show:product:search', childView.model, childView.source);
        },
        onRemoveContent: function(view) {
            this.collection.remove(view.model);
        },
        onRemoveChild: function(view) {
            if (this.collection.length <= 0) {
                App.execute('hide:uploader:loader');
                if (view.model.get('confirming')) {
                    this.trigger('show:confirm:panel');
                } else {
                    this.trigger('update:breadcrumb', 'two', true);
                    this.trigger('show:select:content');
                }
            }
        },
        onChildDeleteUpload: function(_childView, params) {
            this.collection.remove(params.model);
            if (!this.collection.length) {
                this.trigger('update:breadcrumb', 'two', true);
            }
        },
        onChildUpdateBreadcrumb: function(childView, step, backwards) {
            this.trigger('update:breadcrumb', step, backwards);
        },
        onShowSelectContent: function() {
            this.trigger('show:select:content');
        },
        templateHelpers: function() {
            return {
                showSearchDescription: gon.current_account.uploader_product_search_mode !== 'hidden'
            };
        }
    });

    Show.ProductSearchRow = App.Views.ItemView.extend({
        template: require('./templates/product_search_row.jst.ejs'),
        tagName: 'li',
        className: 'product_search_row',
        attributes: {
            role: 'button',
            tabindex: 0
        },
        triggers: {
            'click': 'product:row:clicked'
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
            this.listenTo(this.searchModel, 'change', this.render);
        },
        bolden: function(str, term) {
            if (term === '') {
                return _.escape(str);
            }
            var escapedStr = _.escape(str);
            var regex = new RegExp(_.escape(term), 'gi');
            return escapedStr.replaceAll(regex, '<b>$&</b>');
        },
        templateHelpers: function() {
            const productPhoto = decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'));

            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                return {
                    boldProductName: this.bolden(
                        decodeUtf8(this.model.get('title')),
                        this.searchModel.get('search_term')
                    ),
                    alt: decodeUtf8(this.model.get('title')),
                    src: productPhoto
                };
            } else {
                return {
                    boldProductName: this.bolden(
                        decodeUtf8(this.model.get('name')),
                        this.searchModel.get('search_term')
                    ),
                    alt: decodeUtf8(this.model.get('name')),
                    src: productPhoto
                };
            }
        }
    });

    Show.ProductSearchEmptyView = App.Views.ItemView.extend({
        template: require('./templates/product_search_empty.jst.ejs'),
        className: 'product_search_empty'
    });
    Show.ProductSearchNoResultsView = App.Views.ItemView.extend({
        template: require('./templates/product_search_no_results.jst.ejs'),
        className: 'product_search_no_results'
    });
    Show.ProductSearchLoadingView = App.Views.ItemView.extend({
        template: require('./templates/product_search_loading.jst.ejs'),
        className: 'product_search_loading'
    });

    Show.ProductSearch = App.Views.Layout.extend({
        template: require('./templates/product_search.jst.ejs'),
        id: 'product_search',
        childEvents: {
            'product:row:clicked': function(_collectionView, model) {
                this.triggerMethod('product:row:clicked', model);
            }
        },
        regions: {
            productSearchContainer: '.product_search_results_container'
        },
        ui: {
            productSearchField: '#product_search_field',
            productSearchClearButton: '.product_search_clear',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        events: {
            'input @ui.productSearchField': function(ev) {
                this.searchModel.set('search_term', ev.target.value);
            },
            'click @ui.productSearchClearButton': function() {
                this.searchModel.set('search_term', '');
                this.ui.productSearchField.val('');
            },
            'click @ui.doneTaggingButton': function() {
                var collectionView = this.getRegion('productSearchContainer').currentView;
                if (!collectionView) {
                    return;
                }
                var selectedModel = collectionView.selectedModel;
                this.triggerMethod('done:tagging', selectedModel);
            }
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        },
        onAttach: function() {
            this.getRegion('productSearchContainer').show(new Show.ProductSearchCollectionView({
                collection: this.collection,
                searchModel: this.searchModel
            }));
        },
        templateHelpers: function() {
            return {
                search_term: this.searchModel.get('search_term') || ''
            };
        }
    });

    Show.ProductSearchCollectionView = App.Views.CollectionView.extend({
        tagName: 'ul',
        className: 'product_search_results',
        childView: Show.ProductSearchRow,
        childEvents: {
            'product:row:clicked': function(view) {
                this.triggerMethod('product:row:clicked', view.model);
            }
        },
        collectionEvents: {
            'request sync error reset': 'render'
        },
        getEmptyView: function() {
            if (this.collection.loading) {
                return Show.ProductSearchLoadingView;
            }
            if (this.searchModel.get('search_term') === '') {
                return Show.ProductSearchEmptyView;
            } else {
                return Show.ProductSearchNoResultsView;
            }
        },
        childViewOptions: function() {
            return {
                searchModel: this.searchModel
            };
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        }
    });

    Show.ProductSearchSubcategoryRow = App.Views.ItemView.extend({
        template: require('./templates/product_subcategory_row.jst.ejs'),
        tagName: 'li',
        className: 'product_search_subcategory_row',
        attributes: {
            role: 'button',
            tabindex: 0
        },
        triggers: {
            'click': 'subcategory:row:clicked'
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
            this.listenTo(this.searchModel, 'change', this.render);
        },
        select: function() {
            this.$el.toggleClass('selected', true);
        },
        unselect: function() {
            this.$el.toggleClass('selected', false);
        },
        bolden: function(str, term) {
            if (term === '') {
                return _.escape(str);
            }
            var escapedStr = _.escape(str);
            var regex = new RegExp(_.escape(term), 'gi');
            return escapedStr.replaceAll(regex, '<b>$&</b>');
        },
        templateHelpers: function() {
            return {
                src: decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo')),
                name: this.bolden(decodeUtf8(this.model.get('name')), this.searchModel.get('search_term')),
                alt: decodeUtf8(this.model.get('name'))
            };
        }
    });

    Show.ProductSearchSubcategoryPicker = App.Views.Layout.extend({
        template: require('./templates/product_subcategory_picker.jst.ejs'),
        id: 'product_search',
        childView: Show.ProductSearchSubcategoryRow,
        regions: {
            productSearchContainer: '.product_search_results_container'
        },
        ui: {
            productSearchField: '#product_search_field',
            productSearchClearButton: '.product_search_clear',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        triggers: {
            'subcategory:row:clicked': 'subcategory:row:clicked'
        },
        events: {
            'input @ui.productSearchField': function(ev) {
                this.searchModel.set('search_term', ev.target.value);
            },
            'click @ui.productSearchClearButton': function() {
                this.searchModel.set('search_term', '');
                this.ui.productSearchField.val('');
            },
            'click @ui.doneTaggingButton': function() {
                var collectionView = this.getRegion('productSearchContainer').currentView;
                if (!collectionView) {
                    return;
                }
                var selectedModel = collectionView.selectedModel;
                this.triggerMethod('done:tagging', selectedModel);
            }
        },
        initialize: function(opts) {
            this.selectedModel = null; // will be selected when a row is picked

            this.collection = new Pixlee.Entities.Products([], {
                category_album_id: opts.model.id
            });
            this.searchModel = this.collection.searchModel;
            this.collection.fetch();
        },
        onAttach: function() {
            this.showChildView('productSearchContainer', new Show.ProductSearchSubcategoryPickerCollectionView({
                collection: this.collection,
                searchModel: this.searchModel
            }));
        },
        templateHelpers: function() {
            return {
                search_term: this.searchModel.get('search_term') || '',
                product_photo: decodeUtf8(this.model.get('product_photo_thumb') || this.model.get('product_photo'))
            };
        }
    });

    Show.ProductSearchSubcategoryPickerCollectionView = App.Views.CollectionView.extend({
        tagName: 'ul',
        childView: Show.ProductSearchSubcategoryRow,
        childEvents: {
            'subcategory:row:clicked': function(view) {
                this.selectedModel = view.model;
                var selectedModelId = this.selectedModel.id;
                this.children.each(function(childView) {
                    if (childView.model.id === selectedModelId) {
                        childView.select();
                    } else {
                        childView.unselect();
                    }
                });
            }
        },
        collectionEvents: {
            'request sync error': 'render'
        },
        getEmptyView: function() {
            if (this.collection.loading) {
                return Show.ProductSearchLoadingView;
            }
            if (this.searchModel.get('search_term') !== '') {
                return Show.ProductSearchNoResultsView;
            }
        },
        emptyViewOptions: {
            subcategory: true
        },
        childViewOptions: function() {
            return {
                searchModel: this.searchModel
            };
        },
        initialize: function(opts) {
            this.searchModel = opts.searchModel;
        }
    });

    Show.ProductSearchPanel = App.Views.Layout.extend({
        template: require('./templates/product_search_panel.jst.ejs'),
        id: 'product_search_panel',
        className: 'product_search panel',
        regions: {
            productSearchContainer: '.product_search_container'
        },
        childEvents: {
            'product:row:clicked': 'onProductRowClicked',
            'done:tagging': 'doneTagging'
        },
        ui: {
            backButton: '.product_search_back_button',
            cancelButton: '.product_search_cancel_button',
            doneTaggingButton: '.product_search_done_tagging_button'
        },
        events: {
            'click @ui.backButton': 'showProductSearch',
            'click @ui.cancelButton': 'showReviewPanel'
        },
        initialize: function(options) {
            this.source = options.source;
            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                this.collection = new Pixlee.Entities.Tags();
            } else {
                this.collection = new Pixlee.Entities.Products();
            }
            this.searchModel = this.collection.searchModel;
        },
        onShow: function() {
            this.showProductSearch();
        },
        showReviewPanel: function() {
            this.trigger('show:review:panel', this.source);
        },
        showProductSearch: function() {
            this.ui.backButton.css('visibility', 'hidden');
            this.showChildView('productSearchContainer', new Show.ProductSearch({
                searchModel: this.searchModel,
                collection: this.collection
            }));
        },
        doneTagging: function(_view, selectedModel) {
            this.triggerMethod('done:tagging', selectedModel);
        },
        onProductRowClicked: function(_searchView, model) {
            if (gon.current_account.uploader_product_search_mode === 'tag,product') {
                this.showChildView('productSearchContainer', new Show.ProductSearchSubcategoryPicker({
                    model: model
                }));
                this.ui.backButton.css('visibility', 'visible');
            } else {
                this.trigger('done:tagging', model);
            }
        }
    });

    Show.FormView = App.Views.ItemView.extend({
        template: require('./templates/form_panel.jst.ejs'),
        id: 'panel_form',
        className: 'panel',
        ui: {
            fullNameInputText: '#fullname_input_text',
            clientTosCheckbox: '#client_tos_checkbox',
            emailInputText: '#email_input_text',
            dobInputText: '#dob_input_text',
            nameInput: '#name_input',
            emailInput: '#email_input',
            dobInput: '#dob_input',
            clientTosHolder: '#client_tos_holder',
            clientTosLink: '#client_tos_link a',
            additionalField: '.additional_field'
        },
        behaviors: {
            SubmitContentValidation: {}
        },
        initialize: function() {
            this.connectedUser = Show.connectedUser;
        },
        onValidationSuccess: function() {
            var keenData = {
                email: this.ui.emailInputText.val(),
                name: this.ui.fullNameInputText.val(),
                user_handle: this.model.get('facebook_user_name'),
                channel: this.options.source || 'desktop'
            };
            this.trigger('keen:completed:authorization', keenData);
            this.trigger('show:next:panel');
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'four');
            // create index of focussable elements for keyboard/screen reader users
            this.trigger('get:focus:index', this.$el);
            if (this.options.source !== 'desktop') {
                this.ui.emailInputText.val(this.model.get(this.options.source + '_email_address'));
                this.ui.fullNameInputText.val(this.model.get(this.options.source + '_user_name'));
            }

            if (window._customerProvidedUserProfile) {
                if (window._customerProvidedUserProfile.name) {
                    this.ui.fullNameInputText.val(window._customerProvidedUserProfile.name);
                }
                if (window._customerProvidedUserProfile.email) {
                    this.ui.emailInputText.val(window._customerProvidedUserProfile.email);
                }
            }
        },
        onSubmit: function() {
            Show.connectedUser.set('uniqueID', gon.distinct_user_hash);
        },
        templateHelpers: {
            disableFields: function() {
                return window._customerProvidedUserProfile && window._customerProvidedUserProfile.isImmutable;
            },
            isDefaultNamePlaceholder: function() {
                return App.displayOptions.get('namePlaceholder') === I18n.translations.en.uploader.form.placeholders.fullname;
            },
            getNamePlaceholder: function() {
                return App.displayOptions.get('namePlaceholder');
            },
            isDefaultEmailPlaceholder: function() {
                return App.displayOptions.get('emailPlaceholder') === I18n.translations.en.uploader.form.placeholders.email;
            },
            getEmailPlaceholder: function() {
                return App.displayOptions.get('emailPlaceholder');
            },

            /* Renders customer-defined text boxes. */
            getExtraFields: function() {
                let fields = '';
                const additional = App.displayOptions.get('additional_fields');

                if (!_.isFalsy(additional) && additional.length > 0) {
                    const fieldRenderer = require('./templates/additional_field.jst.ejs');
                    for (let i = additional.length - 1; i >= 0; i--) {
                        fields += fieldRenderer({
                            is_public: additional[i].is_public || false,
                            is_required: additional[i].is_required || false,
                            label_text: additional[i].label_text || '',
                            placeholder_text: additional[i].placeholder_text || ''
                        });
                    }
                }
                return fields;
            },

            /* Renders customer-defined checkboxes. */
            getExtraTosFields: function() {
                var fields = '';
                const tos = App.displayOptions.get('additional_tos_fields');

                if (!_.isFalsy(tos) && tos.length > 0) {
                    const tosRenderer = require('./templates/additional_tos_field.jst.ejs');
                    for (let i = tos.length - 1; i >= 0; i--) {
                        fields += tosRenderer({
                            id: 'additional_tos_field_' + i,
                            isRequired: tos[i].isRequired || '',
                            label: tos[i].label || '',
                            link: tos[i].link || '',
                            linkText: tos[i].linkText || '',
                            labelv2: tos[i].labelv2 || ''
                        });
                    }
                }
                return _.unescape(fields);
            },
            getBrandTOSLinkText: function() {
                return App.displayOptions.get('tosLabel_text');
            },
            getBrandTOSLinkUrl: function() {
                return App.displayOptions.get('tosLink_text');
            }
        }
    });

    Show.FailedSubmissionPanel = App.Views.Layout.extend({
        template: require('./templates/failed_submission_panel.jst.ejs'),
        id: 'panel_failed_submission',
        className: 'panel',
        attributes: {
            'tabindex': '0'
        },
        ui: {
            done: '#done'
        },
        events: {
            'click @ui.done': 'closeParentIFrame'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'hide');
        },
        closeParentIFrame: function() {
            if ('parentIFrame' in window) {
                window.parentIFrame.close();
            }
        }
    });

    Show.SocialPhotoPanelItem = App.Views.ItemView.extend({
        template: false,
        className: 'photo_item',
        attributes: {
            'tabindex': '0'
        },
        modelEvents: {
            'selected': 'selectModel'
        },
        events: {
            'click': 'clickPhoto'
        },
        onShow: function() {
            this.$el.css('background-image', 'url(' + this.model.get('picture') + ')');
        },
        selectModel: function() {
            this.$el.addClass('active');
        },
        clickPhoto: function() {
            if (this.$el.hasClass('active')) {
                this.$el.removeClass('active');
                this.model.collection.trigger('photo:unselected', this.model);
            } else {
                this.$el.addClass('active');
                this.model.collection.trigger('photo:selected', this.model);
            }
        }
    });

    Show.SocialPhotoAlbumItem = App.Views.ItemView.extend({
        template: require('./templates/social_photo_albums_panel_item.jst.ejs'),
        className: 'social_album',
        attributes: {
            'tabindex': '0'
        },
        events: {
            'click': 'clickModel'
        },
        onShow: function() {
            if (this.model.get('name') === 'Tagged Videos') {
                this.$el.addClass('album_video_tagged');
            } else if (this.model.get('name') === 'Uploaded Videos') {
                this.$el.addClass('album_video_uploaded');
            }
        },
        clickModel: function() {
            if (this.model.get('name') === 'Tagged Videos') {
                this.trigger('show:album:videos', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            } else if (this.model.get('name') === 'Uploaded Videos') {
                this.trigger('show:album:videos:uploaded', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            } else {
                this.trigger('show:album:photos', this, {
                    model: this.model,
                    collection: this.model.collection,
                    view: this
                });
            }
        }
    });

    Show.SocialPhotoAlbumPanel = App.Views.CompositeView.extend({
        template: require('./templates/social_photo_albums_panel.jst.ejs'),
        childView: Show.SocialPhotoAlbumItem,
        childViewContainer: '#fb_albums_container',
        id: 'panel_social',
        className: 'panel',
        ui: {
            loadMore: '#load_more'
        },
        triggers: {
            'click #load_more': 'load:more'
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'two');
            this.triggerMethod('loaded');
            // create a focusable element index for keyboard users
            this.trigger('get:focus:index', this.$el);
        },
        onLoaded: function() {
            if (this.options.pagination.next) {
                this.ui.loadMore.show();
            } else {
                this.ui.loadMore.hide();
            }
        }
    });

    Show.SocialPhotoPanel = App.Views.CompositeView.extend({
        template: require('./templates/social_photo_panel.jst.ejs'),
        childView: Show.SocialPhotoPanelItem,
        childViewContainer: '#social_photo_content',
        id: 'panel_social',
        className: 'panel',
        ui: {
            backAlbums: '#back_albums',
            loadMore: '#load_more',
            socialPhotoError: '#social_photo_error',
            socialPhotoEmpty: '#social_photo_empty',
            socialPhotoWrapper: '#social_photo_wrapper',
            reviewSelected: '#review_selected'
        },
        triggers: {
            'click @ui.backAlbums': 'show:album:view',
            'click @ui.loadMore': 'load:more',
        },
        events: {
            'click @ui.reviewSelected': 'reviewSelected'
        },
        collectionEvents: {
            'photo:selected': 'photoSelected',
            'photo:unselected': 'photoUnselected'
        },
        onShow: function() {
            var _this = this;
            this.trigger('update:breadcrumb', 'two');
            // create focusable element index for accessibility
            this.trigger('get:focus:index', this.$el);
            if (this.options.source === 'facebook') {
                this.ui.backAlbums.show();
            } else {
                this.ui.backAlbums.remove();
            }
            if (this.options.uploaderCollection.length > 0) {
                _.each(this.options.uploaderCollection.models, function(model) {
                    var selectedModel = _this.collection.findWhere({
                        id: model.get('id')
                    });
                    if (_.isTruthy(selectedModel)) {
                        selectedModel.trigger('selected');
                    }
                });
            }
            if (!this.collection.length) {
                this.ui.socialPhotoEmpty.show();
            }
            this.onLoaded();
        },
        photoSelected: function(model) {
            this.ui.socialPhotoError.hide();
            this.options.uploaderCollection.add(model);
            // helps determines whether alert prompt will appear for keyboard users
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        photoUnselected: function(model) {
            this.options.uploaderCollection.remove(model);
            // helps determines whether alert prompt will appear for keyboard users
            Show.preventClosing.uploaderCollection = this.options.uploaderCollection.length;
        },
        reviewSelected: function() {
            if (this.options.uploaderCollection.length > 0) {
                this.trigger('show:review:panel', this.options.source);
            } else {
                this.ui.socialPhotoError.show();
                this.ui.socialPhotoError.focus();
                this.ui.socialPhotoWrapper.addClass('error_is_visible');
            }
        },
        onLoaded: function() {
            if (this.options.pagination.next) {
                this.ui.loadMore.show();
            } else {
                this.ui.loadMore.hide();
            }
        },
        onAddChild: function(view) {
            var childType = view.model.get('type');
            if (['image', 'carousel_album'].indexOf(childType) === -1) {
                view.$el.append('<div class="video_content"></div>');
            }
        }
    });

    Show.GooglePickerPanel = App.Views.ItemView.extend({
        template: require('./templates/google_picker_panel.jst.ejs'),
        id: 'panel_google_picker',
        className: 'panel',
        ui: {
            openPicker: '#google_picker_open',
            retry: '#google_picker_retry',
            message: '#google_picker_message',
            error: '#google_picker_error'
        },
        events: {
            'click @ui.openPicker': 'startPickerSession',
            'click @ui.retry': 'startPickerSession'
        },
        initialize: function(options) {
            this.token = options.token;
            this.session = null;
            this.popup = null;
        },
        onShow: function() {
            this.trigger('update:breadcrumb', 'two');
            this.trigger('get:focus:index', this.$el);
        },
        onDestroy: function() {
            this.cleanupSession();
        },
        cleanupSession: function() {
            // Best-effort cleanup so we don't leave orphan sessions sitting on Google's side
            // and so in-flight poll responses know the session has been abandoned (identity
            // check in pollUntilDone). Both .close() and reading .closed can throw under COOP
            // on a cross-origin popup, so the whole block is guarded.
            if (this.session && this.session.id) {
                App.request('delete:google:picker:session', this.token, this.session.id);
            }
            this.session = null;
            if (this.popup) {
                try {
                    this.popup.close();
                } catch (e) {
                    // COOP-blocked or already closed; nothing to do.
                }
                this.popup = null;
            }
        },
        startPickerSession: function() {
            var _this = this;
            this.ui.error.hide();
            this.ui.retry.hide();
            this.ui.openPicker.hide();
            this.ui.message.text('Opening Google Photos picker…');

            // Abandon any prior session so its in-flight poll/list responses are dropped
            // by the identity check in pollUntilDone, and a new popup can be opened cleanly.
            this.cleanupSession();

            App.request('create:google:picker:session', this.token)
                .done(function(session) {
                    if (_this.isDestroyed) {
                        return;
                    }
                    _this.session = session;
                    _this.openPickerPopup(session.pickerUri);
                    _this.pollUntilDone(session);
                })
                .fail(function() {
                    if (_this.isDestroyed) {
                        return;
                    }
                    _this.showError('Could not start the Google Photos picker. Please try again.');
                });
        },
        openPickerPopup: function(pickerUri) {
            var w = 800;
            var h = 600;
            var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
            var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
            var left = ((screen.width / 2) - (w / 2)) + dualScreenLeft;
            var top = ((screen.height / 2) - (h / 2)) + dualScreenTop;
            var opts = 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left;
            this.popup = window.open(pickerUri, 'Google Photos Picker', opts);
            if (this.popup && this.popup.focus) {
                try {
                    this.popup.focus();
                } catch (e) {
                    // COOP can throw on cross-origin .focus(); ignore.
                }
            }
            this.ui.message.text('Pick your photos in Google Photos, then return here.');
        },
        pollUntilDone: function(session) {
            var _this = this;
            // Object-identity check on _this.session: if the user clicked retry (or the view
            // was destroyed), this.session has changed, and any resolution from THIS poll
            // must not overwrite the UI for the new session. The underlying HTTP polling
            // inside the entity keeps running until its own timeout — that's harmless
            // background traffic since we ignore the result here.
            function isStale() {
                return _this.isDestroyed || _this.session !== session;
            }
            App.request('poll:google:picker:session', this.token, session.id, session.pollingConfig)
                .done(function() {
                    if (isStale()) {
                        return;
                    }
                    _this.ui.message.text('Loading your selected photos…');
                    App.request('list:google:picker:items', _this.token, session.id)
                        .done(function(coll) {
                            if (isStale()) {
                                return;
                            }
                            _this.trigger('picker:items:ready', coll.toJSON());
                        })
                        .fail(function() {
                            if (isStale()) {
                                return;
                            }
                            _this.showError('Could not load your selected photos. Please try again.');
                        });
                })
                .fail(function() {
                    if (isStale()) {
                        return;
                    }
                    _this.showError('Google Photos selection timed out. Please try again.');
                });
        },
        showError: function(message) {
            this.ui.error.text(message).show();
            this.ui.retry.show();
            this.ui.message.text('');
        }
    });

    Show.InfoView = App.Views.ItemView.extend({
        template: false,
        className: 'info_panel',
        attributes: {
            tabindex: '0'
        },
        events: {
            'click': 'closePanel'
        },
        onShow: function() {
            // create a focusable element index for keyboard users
            this.trigger('get:focus:index', this.$el.parent());
        },
        closePanel: function() {
            this.$el.hide();
            // reset focus index based on the main content that is now visible
            this.trigger('get:focus:index');
        }
    });
});
